import React from "react";
import { Link } from "react-router-dom";
import { Star, Clock, MapPin } from "lucide-react";
import { useI18n } from "../i18n";
import { eur, pricingLabel } from "../lib/format";

export const ExperienceCard = ({ exp, index = 0 }) => {
  const { t } = useI18n();
  return (
    <Link
      to={`/esperienza/${exp.slug}`}
      data-testid={`experience-card-${exp.slug}`}
      className="group block bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm hover-lift animate-float-up"
      style={{ animationDelay: `${Math.min(index * 60, 400)}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img src={exp.images?.[0]} alt={exp.title} className="h-full w-full object-cover img-zoom" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
        {exp.sponsored && (
          <span data-testid="sponsored-badge" className="absolute top-3 left-3 rounded-full bg-white/90 backdrop-blur px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-accent">
            {t("common.sponsored")}
          </span>
        )}
        {exp.featured && !exp.sponsored && (
          <span className="absolute top-3 left-3 rounded-full bg-secondary/90 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-white">
            Top
          </span>
        )}
        <div className="absolute top-3 right-3 flex items-center gap-1 rounded-full bg-white/90 backdrop-blur px-2 py-1 text-xs font-bold text-slate-800">
          <Star className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400" /> {exp.rating}
        </div>
      </div>
      <div className="p-4">
        <div className="flex items-center gap-3 text-[11px] text-slate-400 mb-1.5">
          <span className="flex items-center gap-1"><Clock className="h-3 w-3" />{Math.round(exp.duration_min / 60 * 10) / 10}h</span>
          <span className="flex items-center gap-1 truncate"><MapPin className="h-3 w-3" />Vieste</span>
        </div>
        <h3 className="font-heading font-semibold text-slate-900 leading-snug line-clamp-2 min-h-[2.6rem] group-hover:text-primary transition-colors">
          {exp.title}
        </h3>
        <p className="text-xs text-slate-400 mt-1 truncate">{exp.operator_name}</p>
        <div className="mt-3 flex items-end justify-between">
          <div>
            <span className="text-[11px] text-slate-400">{t("exp.from")}</span>
            <div className="font-heading font-bold text-lg text-primary">{eur(exp.price)}</div>
            <span className="text-[10px] text-slate-400">{pricingLabel(t, exp.pricing_type)}</span>
          </div>
          <span className="rounded-full bg-primary/5 text-primary text-xs font-semibold px-3 py-1.5 group-hover:bg-primary group-hover:text-white transition-colors">
            {t("exp.book")}
          </span>
        </div>
      </div>
    </Link>
  );
};
